<template>
  <div
    class="Table"
    ref="Table"
  >
    <DragResize
      @onChange="h => $refs.table.$el.style.overflow = h > 80 ? 'auto' : 'inherit'"
      @exportMsg="exportMsg"
      :model="model"
    >
      <div class="Table__content">
        <el-table
          ref="table"
          :data="tableData"
          border
          size="mini"
          style="width: 100%;"
          height="100%"
          row-key="passedIndex"
          highlight-current-row
          @row-click="row => $emit('onPassedIndexChange', {passedIndex: row.passedIndex, type: 'pause'})"
        >
          <el-table-column
            prop="passedIndex"
            label="序号"
            min-width="50"
            align="center"
          >
            <span slot-scope="{row}">{{row.passedIndex + 1}}</span>
          </el-table-column>
          <el-table-column
            prop="ACC"
            label="ACC状态 "
            min-width="100"
            align="center"
          >
            <span slot-scope="{row}">{{row.e === 0?"开":"关"}}</span>
          </el-table-column>
          <el-table-column
            prop="mileage"
            label="里程"
            min-width="100"
            align="center"
          />
          <el-table-column
            prop="locationType"
            label="定位状态 "
            min-width="100"
            align="center"
          >
            <span slot-scope="{row}">{{row.i === 0?"不定位":"Gps定位"}}</span>
          </el-table-column>

          <el-table-column
            prop="stopTime"
            label="停车时长"
            min-width="300"
            align="center"
          />
          <el-table-column
            prop="devTime"
            label="时间"
            min-width="200"
            align="center"
          />
          <el-table-column
            prop="updataType"
            label="数据上传类型"
            min-width="200"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.u === 0?"定时上传":scope.row.u === 1?"定距上传":scope.row.u === 2?"拐点上传":scope.row.u === 3?"ACC 状态改变上传":scope.row.u === 4?"静止最后位置上传":"--"}}
            </template>
          </el-table-column>
          <el-table-column
            prop="activeType"
            label="运动状态"
            min-width="200"
            align="center"
          >
          <template slot-scope="scope">
              <span>{{scope.row.activeType == 1?'行驶':scope.row.activeType == 2?'静止':'离线'}}</span>
          </template>
          </el-table-column>
        </el-table>

        <!-- 分页开始 -->
        <el-pagination
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="playData.length"
        />
        <!-- 分页结束 -->
      </div>
    </DragResize>
  </div>
</template>

<script>
import { isElementInViewport } from "@/assets/js/base";
import DragResize from "./DragResize.vue";

export default {
  components: {
    DragResize
  },

  props: {
    playData: Array,
    passedIndex: Number,
    model:{
      type:Object,
    }
  },

  data() {
    return {
      pageSize: 100
    };
  },

  computed: {
    currentPage: {
      get() {
        return Math.ceil((this.passedIndex + 1) / this.pageSize);
      },

      set(val) {
        const passedIndex = (val - 1) * this.pageSize;
        if (passedIndex === this.passedIndex) return;
        this.$emit("onPassedIndexChange", { passedIndex, type: "jumpTo" });
      }
    },
    tableData() {
      const { playData, currentPage, pageSize } = this;
      const tableData = playData.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
      );
      this.$emit("onTableDataChange", tableData);
      return tableData;
    }
  },

  watch: {
    passedIndex() {
      this.scrollToHighLight();
    }
  },

  methods: {
    exportMsg() {
      this.$emit("exportMsg");
    },
    //滚动到当前高亮节点
    async scrollToHighLight() {
      // if(this.passedIndex ===)
      const row = this.tableData.find(
        ({ passedIndex }) => this.passedIndex === passedIndex
      );
      this.$refs.table.setCurrentRow(row);
      await this.$nextTick();
      const activeDom = this.$refs.table.$el.getElementsByClassName(
        "current-row"
      )[0];
      //如果不在滚动区域内则滚动到滚动区域
      !isElementInViewport(activeDom) &&
        this.$refs.Table.offsetHeight > 80 &&
        activeDom &&
        activeDom.scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
.Table {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 10px;
  z-index: 1024;
  background: #fff;

  &__content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
